import router from './router'
import { useChannelsStore } from './stores/channels'
import { Mode, ModePath, useCurrentChannelStore } from './stores/currentChannel'

const parameters = new URLSearchParams(window.location.search)

export const registerRoutes = () => {
  const channelsStore = useChannelsStore()
  const currentChannelStore = useCurrentChannelStore()

  // GET /luister/{channel_id}/{"mode"} -- for legacy support
  router.register(/^luister\/(.+)\/(listen|watch)$/, async (channelId, mode = Mode.Listen) => {
    currentChannelStore.switchToMode(mode)
    const customChannel =
      channelsStore.channels.find((channel) => channel.station.id === channelId) || channelsStore.main
    await currentChannelStore.set(customChannel, parameters.get('autoPlay') !== 'false')
  })

  // GET /luister/{"mode"} -- for legacy support
  router.register(/^luister\/(listen|watch)$/, async (mode) => {
    currentChannelStore.switchToMode(mode)
    await currentChannelStore.set(channelsStore.main, parameters.get('autoPlay') !== 'false')
  })

  // GET /{mode?}/{channel_id?}
  router.register(/^(listen|watch|luister|kijk)?\/?(.+)?$/, async (modeName = 'listen', channelId = null) => {
    const mode = Object.keys(ModePath).find((key) => ModePath[key] === modeName) || modeName
    currentChannelStore.switchToMode(mode)
    const customChannel =
      channelsStore.channels.find((channel) => channel.station.id === channelId) || channelsStore.main
    await currentChannelStore.set(customChannel, parameters.get('autoPlay') !== 'false')
  })
}
